import React from 'react';
import { Link } from 'react-router-dom';
import StepHelpButton from '../StepHelpButton';
import WorkshopFirstStepSignupCard from './WorkshopFirstStepSignupCard';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopStepWorkSectionProps {
  meetingCode: string | null;
  canFacilitate?: boolean;
}

const WorkshopStepWorkSection: React.FC<WorkshopStepWorkSectionProps> = ({
  meetingCode,
  canFacilitate = false,
}) => (
  <>
    <section className={styles.zoomBlockFeatured}>
      <div className={styles.workshopHelpRow}>
        <Link to="/saa?tab=steps" className={styles.stepWorkButton}>
          Work my steps
        </Link>
        <StepHelpButton stepKey="workshop" />
      </div>
    </section>
    {meetingCode && (
      <WorkshopFirstStepSignupCard
        meetingCode={meetingCode}
        canFacilitate={canFacilitate}
      />
    )}
  </>
);

export default WorkshopStepWorkSection;
